import { AccessLevel } from '../../store/user/types'

export function shouldShowBotActions(accessLevel: AccessLevel): boolean {
  if (accessLevel.tokenLogin) {
    return false
  }

  if (!accessLevel.isLoggedIn) {
    return false
  }

  if (!accessLevel.verifiedEmail) {
    return false
  }

  return true
}
